import { IPropertyInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/IPropertyInfoMetadata";
import { ITypeInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/ITypeInfoMetadata";
import { EntityBaseProperties, IEntityBaseProperties } from "@seriously-rad/seriouslyrad-framework-core/Server/Schema/Entities/BaseTypes/EntityBaseProperties";
import { ISoftDeletableEntityProperties, SoftDeletableEntityProperties } from "@seriously-rad/seriouslyrad-framework-core/Server/Schema/Entities/BaseTypes/SoftDeletableEntityProperties";

export interface IMediationAdviceProtocolProperties extends IEntityBaseProperties, ISoftDeletableEntityProperties
{

    // #region Basic Properties

    paragraphReference: IPropertyInfoMetadata;
    protocolHtml: IPropertyInfoMetadata;
    notes: IPropertyInfoMetadata;

    // #endregion

}

export const MediationAdviceProtocol: ITypeInfoMetadata<IMediationAdviceProtocolProperties> = {
    attributes: [
        {
            id: "{01BA1829-467A-4E6F-A5CA-C0B679A8E46F}",
            $type: "SeriouslyRAD.Framework.ClientAwareIdAttribute, SeriouslyRAD.Framework"
        },
        {
            name: "MediationAdviceProtocol",
            nameFriendly: "Mediation Advice Protocol",
            namePlural: "MediationAdviceProtocols",
            namePluralFriendly: "Mediation Advice Protocols",
            $type: "SeriouslyRAD.Framework.ClientAwareNameAttribute, SeriouslyRAD.Framework"
        }
    ],
    classHierarchy: [
        "GlobalMediation.Data.Entities.MediationAdviceProtocol, GlobalMediation.Data.Entities",
        "SeriouslyRAD.Framework.Data.EntityBase, SeriouslyRAD.Framework.Data.Entities",
        "System.Object, System.Private.CoreLib"
    ],
    hasEnumFlags: false,
    name: "MediationAdviceProtocol",
    properties: {
        ...EntityBaseProperties,
        ...SoftDeletableEntityProperties,
        paragraphReference: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Paragraph Reference"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediationAdviceProtocol+ParagraphReferenceMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 0
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ParagraphReference",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        protocolHtml: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Protocol"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediationAdviceProtocol+ProtocolHtmlMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 1
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ProtocolHtml",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        notes: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Notes"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 2
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Notes",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        }
    },
    underlyingTypeId: "GlobalMediation.Data.Entities.MediationAdviceProtocol, GlobalMediation.Data.Entities",
    $type: "SeriouslyRAD.Framework.Reflection.TypeInfoMetadata, SeriouslyRAD.Framework"
};

